import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneHealthTab');

    return {
        BATTERY_CYCLES: t('batteryCycles'),
        DRONE_SERIAL_NUMBER: t('droneSerialNumber'),
        EXPIRED: t('expired'),
        FAA_REGISTRATION: t('faaRegistration'),
        FIRMWARE: t('firmware'),
        LAST_LEVEL_CALIBRATION: t('lastLevelCalibration'),
        LAST_MAGNETOMETER_CALIBRATION: t('lastMagnetometerCalibration'),
        LAST_PUMP_CALIBRATION: t('lastPumpCalibration'),
        LAST_WEIGHT_CALIBRATION: t('lastWeightCalibration'),
        TOTAL_FLIGHT_HOURS: t('totalFlightHours'),
        WARRANTY_END: t('warrantyEnd'),
        WARRANTY_REMAINING: t('warrantyRemaining'),
        WARRANTY_START: t('warrantyStart')
    };
};

export default useTranslation;
